/**
 * RISKS.HOME
 * List of units
 */

import { useEffect } from "react"
import { useAppDispatch } from "@/core/root-reducer"
import unitStore from "../entities/unit/model/unit.store"
import riskStore from "../entities/risk/model/risk.store"
import { useLocation } from "react-router-dom"
import { resetStoresSearch } from "../utils/resetStoresSearch"
import { RISKS_TABS } from "../utils/risks-tabs.config"
import NavRisks from "../ui/nav-risks"
import { ReactFlowProvider } from "@xyflow/react"
import RisksUnitsFlow from "../entities/unit/ui/RisksUnitsFlow"

export default function RisksUnitsRoute() {
  const dispatch = useAppDispatch()
  const { pathname, search } = useLocation()

  useEffect(() => {
    dispatch(unitStore.thunks.fetchAndSet())
    dispatch(riskStore.thunks.fetchValidatedAndSet(null))

    resetStoresSearch(dispatch, [riskStore, unitStore])
  }, [dispatch, pathname, search])

  return (
    <NavRisks tabs={RISKS_TABS}>
      <ReactFlowProvider>
        <RisksUnitsFlow />
      </ReactFlowProvider>
    </NavRisks>
  )
}
